import { gql } from '@apollo/client';
import { DocumentNode } from 'graphql';

export const GET_CUSTOMER_ADDRESSES: DocumentNode = gql`
  query GetCustomerAddresses {
    getCustomerAddresses {
      id
      firstName
      lastName
      name
      phone
      customerId
      address1
      address2
      zip
      city
      country
      provinceCode
      countryCode
      province
      countryName
      company
      default
    }
  }
`;

export const GET_CUSTOMER_ADDRESS: DocumentNode = gql`
  query GetCustomerAddress($addressId: ID!) {
    getCustomerAddress(addressId: $addressId) {
      id
      firstName
      lastName
      name
      phone
      customerId
      address1
      address2
      zip
      city
      country
      provinceCode
      countryCode
      province
      countryName
      company
      default
    }
  }
`;

export const ADD_CUSTOMER_ADDRESS: DocumentNode = gql`
  mutation AddCustomerAddress($customerAddressInput: CustomerAddressInput!) {
    addCustomerAddress(address: $customerAddressInput) {
      id
      firstName
      lastName
      name
      phone
      customerId
      address1
      address2
      zip
      city
      country
      provinceCode
      countryCode
      province
      countryName
      company
      default
    }
  }
`;

export const UPDATE_CUSTOMER_ADDRESS: DocumentNode = gql`
  mutation UpdateCustomerAddress(
    $addressId: ID!
    $customerAddressInput: CustomerAddressInput!
  ) {
    updateCustomerAddress(
      addressId: $addressId
      address: $customerAddressInput
    ) {
      id
      firstName
      lastName
      name
      phone
      customerId
      address1
      address2
      zip
      city
      country
      provinceCode
      countryCode
      province
      countryName
      company
      default
    }
  }
`;

export const DELETE_CUSTOMER_ADDRESS: DocumentNode = gql`
  mutation DeleteCustomerAddress($addressId: ID!) {
    removeCustomerAddress(addressId: $addressId)
  }
`;
